<template>
  <ReaderInterludeMiddle
    class="sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg mx-auto"
    :cardClass
    @nextChapter="emit('nextChapter')"
    @openComments="emit('openComments')"
  >
    <template v-if="nextChapter" #next>
      <NovelChapterCard
        :chapter="nextChapter"
        no-lang
        :chapter-kind="title?.attributes.chapterKind"
        :volume-kind="title?.attributes.volumeKind"
        :title-cover-url="coverUrl"
        no-link
        @click="emit('nextChapter')"
      >
        <template #contextMenu>
          <div></div>
        </template>
      </NovelChapterCard>
    </template>
    <template v-if="chapter && title" #share>
      <NovelChapterShareBlock :chapter="chapter" :title="title" />
    </template>
    <template #comments>
      <FeedComments
        class="p-2 -m-2"
        :feed-id="chapter?.id ?? ''"
        feed-type="novel_chapter"
        preview
        collapse-replies
      />
    </template>
  </ReaderInterludeMiddle>
</template>

<script setup lang="ts">
import {
  getCoverUrl,
  type NovelChapterEntity,
  type TitleEntity,
} from "~/src/api";
import { useQuery } from "@tanstack/vue-query";

const { nextId, title } = defineProps<{
  nextId?: string;
  chapter?: NovelChapterEntity;
  title?: TitleEntity;
  cardClass?: string;
}>();

const emit = defineEmits<{
  (e: "nextChapter"): void;
  (e: "openComments"): void;
}>();

const { data: nextChapter } = useQuery(useNovelChapterGet(() => nextId ?? ""));
const coverUrl = computed(() => (title ? getCoverUrl(title, "256") : ""));
</script>

<style scoped lang="postcss"></style>
